import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BillingExport as BillingExport23 } from 'projects/flow-gui-access/views/2.3/core'
import { BillingExport as BillingExport24 } from 'projects/flow-gui-access/views/2.4/core'

class BillingExport extends Component {
  render () {
    if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.4').length !== 0) {
      return <BillingExport24 {...this.props} />
    } else if (this.props.configReducer.endpoints.filter(endpoint => endpoint.name === 'accesses' && endpoint.version === '2.3').length !== 0) {
      return <BillingExport23 {...this.props} />
    } else return false
  }
}
export default connect(state => state)(BillingExport)



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/views/middlewares/core/billing.js